import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

import { isServerSide } from '../../client/listings-client/util/isServerSide'

const PCLNExptContext = createContext(null)

const DEFAULT = 'DEFAULT'
const CONTROL = 'CONTROL'

export const usePCLNExpt = () => {
  const pclnExpt = useContext(PCLNExptContext) // Null if initialization failed

  const fireImpression = (experimentTagName) => {
    if (!isServerSide) {
      pclnExpt?.fireImpression(experimentTagName)
    }
  }

  const getTestState = (experimentTagName) => {
    return pclnExpt?.getTestState(experimentTagName)
  }

  const isVariant = (experimentTagName) => {
    const testState = getTestState(experimentTagName)
    return testState !== DEFAULT && testState !== CONTROL
  }

  const isDefault = (experimentTagName) => {
    return getTestState(experimentTagName) === DEFAULT
  }

  const isControl = (experimentTagName) => {
    return getTestState(experimentTagName) === CONTROL
  }

  return { isDefault, isVariant, isControl, fireImpression, getTestState, pclnExpt }
}

export const PCLNExptProvider = ({ children, pclnExpt }) => {
  return <PCLNExptContext.Provider value={pclnExpt}>{children}</PCLNExptContext.Provider>
}

PCLNExptProvider.propTypes = {
  children: PropTypes.node,
  pclnExpt: PropTypes.object,
}
